import { render } from "./region-select.component.vue?vue&type=template&id=1398cde6"
import script from "./region-select.component.vue?vue&type=script&lang=js"
export * from "./region-select.component.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./region-select.component.vue?vue&type=style&index=0&id=1398cde6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip});
